import { render, staticRenderFns } from "./explore_premium_modal.vue.js?vue&type=template&id=5b23ca7d!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./explore_premium_modal.vue?vue&type=template&id=5b23ca7d"
import script from "./explore_premium_modal.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./explore_premium_modal.vue?vue&type=script&lang=js"
export * from "./explore_premium_modal.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./explore_premium_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b23ca7d')) {
      api.createRecord('5b23ca7d', component.options)
    } else {
      api.reload('5b23ca7d', component.options)
    }
    module.hot.accept("./explore_premium_modal.vue.js?vue&type=template&id=5b23ca7d!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./explore_premium_modal.vue?vue&type=template&id=5b23ca7d", function () {
      api.rerender('5b23ca7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ee/app/assets/javascripts/super_sidebar/components/explore_premium_modal.vue"
export default component.exports